import { trackEcommerce, eventNameConstants, type EcomPromotion } from 'dibs-tracking';

import { getPromoCreative } from '../../helpers/getPromoCreative.js';

type TrackingInput = {
    item: { linkData: { path: string | null } };
    index: number;
    editorialModuleOrder: number;
};

const getEditorialPromoObj = ({
    item,
    index,
    editorialModuleOrder,
}: TrackingInput): EcomPromotion => {
    const url = item?.linkData?.path || '';
    const position = index + 1;
    // In case of 2+ editorial modules orderPrefix requires to be updating required
    const orderPrefix = editorialModuleOrder > 1 ? `${editorialModuleOrder}nd` : '';

    return {
        id: `${orderPrefix}content-promo-${position}`,
        name: `${orderPrefix} Content Promo #${position}`,
        creative: getPromoCreative(url),
        position: position,
    };
};

export const trackEditorialImpression = ({
    item,
    index,
    editorialModuleOrder,
}: TrackingInput): void => {
    trackEcommerce({
        type: 'promotionImpression',
        eventName: eventNameConstants.EVENT_VIEW_PROMOTION,
        promotions: [getEditorialPromoObj({ item, index, editorialModuleOrder })],
    });
};

export const trackEditorialClick = ({ item, index, editorialModuleOrder }: TrackingInput): void => {
    trackEcommerce({
        type: 'promoClick',
        eventName: eventNameConstants.EVENT_SELECT_PROMOTION,
        promotions: [getEditorialPromoObj({ item, index, editorialModuleOrder })],
    });
};
